export default __webpack_public_path__ + "static/media/attractions2.67368a15.avif";